import SearchIcon from "@mui/icons-material/Search";
import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setSelectedSearchBrand } from "../../../../../../../features/trendsSlice";
import { useEffect } from "react";
const TrendsBDBrandsSearch = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { brandsDataTrendsBreakdown, selectedSearchBrand } = useSelector(
    (state: any) => state.trends
  );
  const options =
    brandsDataTrendsBreakdown?.data?.data?.query_output?.map(
      (item: any) => item.brand_name
    ) || [];
  const uniqueOptions = Array.isArray(options)
    ? Array.from(new Set(options)).filter(Boolean)
    : [];

  const handleChange: any = (_: any, newValue: string | null) => {
    dispatch(setSelectedSearchBrand(newValue));
    if (newValue) {
      searchParams.set("brandSearch", newValue);
    } else {
      searchParams.delete("brandSearch");
    }
    setSearchParams(searchParams);
  };

  useEffect(() => {
    // Update selectedBrand when searchParams change (e.g., on back/forward navigation)
    const brandSearch = searchParams.get("brandSearch") || "";
    dispatch(setSelectedSearchBrand(brandSearch));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {" "}
      <Stack
        flexDirection={"row"}
        justifyContent={"start"}
        gap={4}
        sx={{ paddingBlock: "16px" }}
      >
        <Autocomplete
          sx={{ width: "350px" }}
          options={uniqueOptions}
          onChange={handleChange}
          value={selectedSearchBrand || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Brand Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "10px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
      </Stack>
    </>
  );
};

export default TrendsBDBrandsSearch;
